import { render } from "./SearchResults.vue?vue&type=template&id=3b494cae&scoped=true&ts=true"
import script from "./SearchResults.ts?vue&type=script&lang=ts&external"
export * from "./SearchResults.ts?vue&type=script&lang=ts&external"

import "./SearchResults.scss?vue&type=style&index=0&id=3b494cae&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b494cae"]])

export default __exports__